import { WebAPIChartSlicerData } from '../../../globals/webApiTypes/elements/WebAPICBS';
import { CBSStatlineDataset } from '../cbsStatline.types';
import { convertCbsPeriodToDate } from './convertCbsPeriodToDate';

// Parse the raw data from CBS into a dataEntryList
export const parseDataset = (
	dataset: CBSStatlineDataset,
	chartSlicerData: WebAPIChartSlicerData,
) => {
	const { periodType, categoryKeys, topicKeys } = chartSlicerData;

	return dataset.map((datasetItem) => ({
		id: datasetItem.ID,
		periodType,
		periodDate: convertCbsPeriodToDate(datasetItem, chartSlicerData),
		categories: Object.keys(categoryKeys).reduce(
			(acc, key) => ({ ...acc, [key]: datasetItem[key] }),
			{},
		),
		values: topicKeys.reduce(
			(acc, key) => ({ ...acc, [key]: datasetItem[key] }),
			{},
		),
	}));
};
